const pdfHistory = async (token, id) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/view_docHistory/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default pdfHistory;
